---
version: "Roadmap update"
title: "Coverage comes from your CI, not from DebtDrone running your tests"
date: 2026-09-27
excerpt: "We withdrew the planned Docker-in-Docker test-coverage item. Coverage will come from the reports your CI already produces, tied to the commit DebtDrone scanned."
---

## What changed

Our roadmap listed **Docker-in-Docker for Test Coverage** for Q3 2026: DebtDrone would run your test suites in containers during hosted scans to measure coverage. We have withdrawn that item. It never shipped, and we will not run arbitrary customer test suites during hosted scans.

It is replaced by **Coverage from your CI reports**, now on the roadmap for Q4 2026 and in progress. Here is how it will work:

- You upload the coverage report your existing CI already produces; DebtDrone does not execute your tests.
- The report will be tied to the commit DebtDrone scanned, so coverage always describes the code that was analyzed.
- Supported formats: Go coverprofile, LCOV, Cobertura, JaCoCo, Clover, and SimpleCov.
- A repository without a report for that commit will show coverage as **unavailable**, not 0%.

## Why

Running your test suite means running your code, with its dependencies, network access and secrets, on our infrastructure. That is a large security and reliability surface to add to every scan, and it would still be less accurate than the environment your CI already maintains for those tests. Importing the report you already have keeps scans predictable and leaves test execution where it belongs.

Coverage stays optional: complexity, dependency and security findings do not depend on it.
